import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0b4120"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white sales-pos-location-box hour-analysis-card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hour-analysis-card__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-muted fs-13 d-block mb-5 text-uppercase" }, " Métricas comparativas "),
    /*#__PURE__*/_createElementVNode("h4", { class: "card-title fw-black mb-0" }, "Análise de horário")
  ])
], -1))
const _hoisted_4 = { class: "hour-analysis-card__summary" }
const _hoisted_5 = { class: "hour-analysis-card__summary-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Funcionamento", -1))
const _hoisted_7 = { class: "hour-analysis-card__summary-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pico de agendamentos", -1))
const _hoisted_9 = { class: "hour-analysis-card__summary-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Pico de cancelamentos", -1))
const _hoisted_11 = {
  id: "weeklySalesChart",
  class: "chart hour-analysis-card__chart-wrap"
}
const _hoisted_12 = { class: "hour-analysis-card__chart-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("strong", null, _toDisplayString(_ctx.operatingWindow), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("strong", null, _toDisplayString(_ctx.peakScheduled.hour) + " | " + _toDisplayString(_ctx.peakScheduled.value), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("strong", null, _toDisplayString(_ctx.peakCanceled.hour) + " | " + _toDisplayString(_ctx.peakCanceled.value), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          (_ctx.chartSeries.length)
            ? (_openBlock(), _createBlock(_component_apexchart, {
                key: "hour-analysis-chart",
                type: "area",
                height: _ctx.chartHeight,
                options: _ctx.chartOptions,
                series: _ctx.chartSeries
              }, null, 8, ["height", "options", "series"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}